import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../../shared/JVInput";

interface IProps {
    open: boolean;
    jobDetails: any;
    singleData: any;
    hideDialog: () => void;
    toast: any;
}

interface IPOC {
    jobPostingId?: number,
    pOCName?: string,
    pOCEmail?: string,
    createdBy?: number,
}

const schema = yup.object({
    jobPostingId: yup.number().required("jobPostingId is Required"),
    pOCName: yup.string().required("POC Name is Required"),
    pOCEmail: yup.string().email().required("POC Email is Required"),
    createdBy: yup.number().nullable()
});

export const POCForm = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [emailPatterns, setEmailPatterns] = useState<Array<string>>([]);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IPOC>({
        resolver: yupResolver(schema),
        defaultValues: {
            jobPostingId: 0,
            pOCName: "",
            pOCEmail: "",
        },
        shouldFocusError: false,
    });

    const saveToDB = async (body: any) => {

        setLoading(true);

        const response = await Fetch(`lead-capture/JobPostingPOC`, "POST", body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: "success", detail: "POC Added Successfully.", life: 3000 });
        }

        setLoading(false);
    };

    const loadEmailPatterns = async (vendorCompanyId: number) => {
        setLoading2(true);
        const response = await Fetch("name_email_patterns", "GET", null, `vendorCompanyName=${vendorCompanyId}`, null);
        if (response) {
            const data: Array<string> = await response.json();
            setEmailPatterns(data);
            setLoading2(false);
        } else setLoading2(false);
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    const onHide = () => {
        setLoading2(false);
        props.hideDialog();
        reset();
    };

    const header = () => {
        return <span>Add POC</span>;
    };

    useEffect(() => {
        if (props.open) {
            loadEmailPatterns(props?.jobDetails?.companyName || "");
            reset({ jobPostingId: props.jobDetails.id, pOCName: props?.singleData.pOCName || "", pOCEmail: props?.singleData.pOCEmail || "" });
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: "80vw", overflowY: "scroll" }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required disabled column={3} label="Job ID" control={control} name="jobPostingId" error={errors.jobPostingId?.message} />
                <JVInput required column={3} label="Name" control={control} name="pOCName" error={errors.pOCName?.message} />
                <JVInput required column={3} label="Email" control={control} name="pOCEmail" error={errors.pOCEmail?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <p>Email Patterns: {loading2 === true ? "Loading..." : ""} {emailPatterns.length > 0 && <span className="text-purple-500 font-bold">{emailPatterns.join("  |  ")}</span>}</p>
                </div>
                <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px", }} >
                    <Button className="field col-12 md:col-6  h-2rem" label="SEND" type="submit" loading={loading} ></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button" ></Button>
                </div>
            </form>
        </Dialog>
    );
}